import type { CSSProperties } from 'react';
import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Divider } from '~/commonComponents';
import { WarningSolidIcon } from '~/images/icons';

interface ISuspendedBannerProps {
  counts: number;
  style?: CSSProperties;
}

export const SuspendedBanner = ({ counts, style }: ISuspendedBannerProps) => {
  if (counts === 0) {
    return null;
  }

  return (
    <Row
      align="center"
      gap={3}
      p={3}
      className="bg-warning-30 border border-warning-700 rounded-md"
      style={{ marginInline: 72, ...style }}
    >
      <WarningSolidIcon color={colors.warning[500]} size={24} />
      <Divider height="95%" width={1} color={colors.warning[500]} />
      <Column>
        <Typography as="span" bold color={colors.warning[700]} style={{ marginBottom: 4 }}>
          Jobs Suspended, Update Payment Now
        </Typography>
        <Typography as="span" color={colors.warning[700]}>
          {counts} of your job postings have been suspended due to a failed payment. Please go to
          the Suspended tab to
          <br />
          update your payment method to prevent these jobs from being permanently closed.
        </Typography>
      </Column>
    </Row>
  );
};
